export class InsufficientPermissionsError extends Error {
  constructor() {
    super("You don't have the required permissions to do this.");
    // see: typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = InsufficientPermissionsError.name; // stack traces display correctly now
  }
}
